import { render, staticRenderFns } from "./NerisIncidents.vue?vue&type=template&id=c7153104&"
import script from "./NerisIncidents.vue?vue&type=script&lang=js&"
export * from "./NerisIncidents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports